import React, { useEffect, useState } from 'react';

import StatusCell from '../../../components/Badge/StatusCell';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import CheckWithCircleIcon from '../../../components/Icons/CheckWithCircleIcon';
import MessageIcon from '../../../components/Icons/MessageIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import AddressComplaintModal from '../../../components/Modal/ModalActions/AddressComplaintModal/AddressComplaintModal';
import ViewComplaintModal from '../../../components/Modal/ModalActions/ViewComplaintModal/ViewComplaintModal';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableFirstAndLastNameFormatter from '../../../components/Table/TableAccessories/TableFirstAndLastNameFormatter';
import TableImageModal from '../../../components/Table/TableAccessories/TableImageModal';
import BAFilterForm from '../../../components/Table/TableFilterForms/BAFilterForm';
import ViewBADriverInfoCell from '../../../components/Table/TableMobileRowCell/ViewBADriverInfoCell';
import {
  BA_DRIVER_VERIFICATION,
  BA_DRIVER_VERIFICATION_VIEW_COMPLAINT_SALES_ADMIN,
} from '../../../routes/routeConstants';

const BADriverVerificationViewComplaintSalesAdmin = () => {
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver Verification`,
        link: `/${BA_DRIVER_VERIFICATION}`,
      },
      {
        name: `View Complaints`,
        link: `/${BA_DRIVER_VERIFICATION_VIEW_COMPLAINT_SALES_ADMIN}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver Verification'>
      <PageLayout noTitle={true}>
        <BreadCrumbs pathData={pathArr as any} />
        <Table
          tableTitle='COMPLAINTS LIST'
          tableFilterBoxFeatures={{
            showSearchBox: true,
            searchBoxPlaceholder: 'Search',
            rightAttr: [
              {
                type: 'filter',
                comp: <BAFilterForm />,
              },
              // {
              //   type: 'regular',
              //   comp: <ExportBaData />,
              // },
            ],
          }}
          tableHeader={{
            'Date Submitted': 'submittedAt',
            'Company Name': 'company',
            'Driver Name': 'driverName',
            Complaint: 'complaint',
            Status: 'status',
          }}
          tableDataSourceUrl='ba/v1/drivers/verification/complaints'
          cellsCustomComp={{
            submittedAt: <TableDateFormatter dataKey='submittedAt' />,
            status: <StatusCell statusKey='status' hasDot />,
            firstName: (
              <TableFirstAndLastNameFormatter
                firstNameDataKey='firstName'
                lastNameDataKey='lastName'
              />
            ),
            driverImage: <TableImageModal dataKey='driverImage' />,
          }}
          moreOptionsComponents={[
            <ActionRowWithModal
              key='View complaint'
              label='View complaint'
              width='200px'
              icon={<MessageIcon />}
              modalCompFn={(data) => <ViewComplaintModal data={data} />}
              conditionalRenderFn={(data: any) =>
                data?.status !== 'Pending' &&
                data?.status !== 'Processed' &&
                data?.status !== 'Resolved'
              }
            />,
            <ActionRowWithModal
              key='Address complaint'
              label='Address complaint'
              width='200px'
              icon={<CheckWithCircleIcon />}
              modalCompFn={(data) => <AddressComplaintModal data={data} />}
              conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
            />,
          ]}
          mobileCellComp={<ViewBADriverInfoCell />}
        />
      </PageLayout>
    </Page>
  );
};

export default BADriverVerificationViewComplaintSalesAdmin;
